module.exports = __webpack_public_path__ + "static/media/heart_icon_white.48df7550.svg";